import { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import { NavigationBar } from "../navigation-bar/navigation-bar";
import { MovieCard } from "../movie-card/movie-card";
import { MovieView } from "../movie-view/movie-view";
import { LoginView } from "../login-view/login-view";
import { ProfileView } from "../profile-view/profile-view";
import { SignupView } from "../signup-view/signup-view";

export const MainView = () => {
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const storedToken = localStorage.getItem("token");
  const [movies, setMovies] = useState([]);
  const [filteredMovies, setFilteredMovies] = useState(movies);
  const [selectedMovie, setSelectedMovie] = useState(null);
  const [user, setUser] = useState(storedUser ? storedUser : null);
  const [token, setToken] = useState(storedToken ? storedToken : null);

  function handleSearch(event) {
    const searchQuery = event.target.value.toLocaleLowerCase();
    if (searchQuery === "") {
      setFilteredMovies(movies);
    } else {
      const searchResult = movies.filter(
        (movie) =>
          movie.title.toLowerCase().includes(searchQuery) ||
          movie.director.name.toLowerCase().includes(searchQuery)
      );
      setFilteredMovies(searchResult);
    }
  }

  useEffect(() => {
    if (!token) {
      return;
    }

    fetch("https://movie-api-m3ac.onrender.com/movies", {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => response.json())
      .then((data) => {
        const moviesFromApi = data.map((doc) => {
          console.log("data: ", data);
          return {
            id: doc._id,
            title: doc.Title,
            description: doc.Description,
            genre: {
              name: doc.Genre.Name,
              description: doc.Genre.Description,
            },
            director: {
              name: doc.Director.Name,
              bio: doc.Director.Bio,
              birth: doc.Director.Birth,
              death: doc.Director.Death,
            },
            image: doc.ImagePath,
          };
        });
        //alert(JSON.stringify(moviesFromApi))
        console.log(moviesFromApi);
        setMovies(moviesFromApi);
        setFilteredMovies(moviesFromApi);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [token]);

  return (
    <BrowserRouter>
      <NavigationBar
        user={user}
        handleSearch={handleSearch}
        onLoggedOut={() => {
          setUser(null);
          setToken(null);
          localStorage.clear();
        }}
      />

      <Container>
        <Row className="justify-content-md-center">
          <Routes>
            <Route
              path="/signup"
              element={
                <>
                  {user ? (
                    <h3>Test</h3>
                  ) : (
                    <Col md={5}>
                      <SignupView />
                    </Col>
                  )}
                </>
              }
            />

            <Route
              path="/login"
              element={
                <Col md={5}>
                  <LoginView
                    onLoggedIn={(user, token) => {
                      setUser(user);
                      setToken(token);
                    }}
                  />
                </Col>
              }
            />

            <Route
              path="/movies/:movieId"
              element={
                <>
                  {!user ? (
                    <Navigate to="/" />
                  ) : movies.length === 0 ? (
                    <Col>The list is empty!</Col>
                  ) : (
                    <Col>
                      <MovieView
                        movies={movies}
                        movie={selectedMovie}
                        user={user}
                        updateUserOnFav={(user) => {
                          setUser(user);
                          localStorage.setItem("user", JSON.stringify(user));
                        }}
                      />
                    </Col>
                  )}
                </>
              }
            />

            <Route
              path="/"
              element={
                <>
                  {!user ? (
                    <Navigate to="/login" />
                  ) : (
                    <>
                      {filteredMovies.map((movie) => (
                        <Col
                          className="mb-5 col-12 col-md-6 col-lg-4 col-xl-3"
                          key={movie.id}
                        >
                          <MovieCard movie={movie} />
                        </Col>
                      ))}
                      <Row>
                        <Col className="text-end mt-2">
                          <Button
                            onClick={() => {
                              setUser(null);
                              setToken(null);
                              localStorage.clear();
                            }}
                            variant="primary"
                            size="lg"
                            className="mb-5"
                          >
                            Sign out
                          </Button>
                        </Col>
                      </Row>
                    </>
                  )}
                </>
              }
            />

            {/* User Profile view */}
            <Route
              path="/users/:username"
              element={
                <>
                  {!user ? (
                    <Navigate to="/login" />
                  ) : (
                    <Col>
                      <ProfileView movies={movies} />
                    </Col>
                  )}
                </>
              }
            />
          </Routes>
        </Row>
      </Container>
    </BrowserRouter>
  );
};
